import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import PopupIcons from "../components/PopupIcons";
import PopupLightbox from "../components/PopupLightbox";

import imgBook from "../images/thumbs/books.jpg";
import imgStudentDemographic from "../images/thumbs/faculty-student-demographic.jpg";
import imgCalc from "../images/thumbs/calc.jpg";
import imgGraph from "../images/thumbs/bar-graph.jpg";
import imgSpeaker from "../images/misc/icon-speaker.jpg";
import imgPeople from "../images/thumbs/professorship.jpg";
import sarahJ from "../images/bio/sarahJ.jpg";
import nicoleD from "../images/bio/nicoleD.jpg";
import graphBSAcc from "../images/graph-BS-Acc-Students.png";
import graphMAcc from "../images/graph-MAcc-Students.png";

const MiddleY = (props) => {
  const [buttonPopupB1, setButtonPopupB1] = useState(false);
  const [buttonPopupB2, setButtonPopupB2] = useState(false);
  const [buttonPopupB3, setButtonPopupB3] = useState(false);
  const [buttonPopupB4, setButtonPopupB4] = useState(false);
  const [buttonPopupB5, setButtonPopupB5] = useState(false);
  const [buttonPopupB6, setButtonPopupB6] = useState(false);
  const [buttonPopupB7, setButtonPopupB7] = useState(false);
  const [buttonPopupB8, setButtonPopupB8] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { buttonPopupB, onUpdatePopupB } = props;

  useEffect(() => {
    if (
      location.pathname === "/faculty-published-textbooks" ||
      location.pathname === "/faculty-published-textbooks/"
    ) {
      setButtonPopupB1(true);
      onUpdatePopupB(false); // Hide main popup if needed
    } else if (
      location.pathname === "/faculty-and-students" ||
      location.pathname === "/faculty-and-students/"
    ) {
      onUpdatePopupB(true); // Show main popup
      setButtonPopupB1(false);
    } else {
      // For any other route, hide all popups or navigate as needed
      onUpdatePopupB(false);
      setButtonPopupB1(false);
      // Optionally navigate to home or another default route
      // navigate("/");
    }
  }, [location.pathname, onUpdatePopupB]);

  useEffect(() => {
    // Only navigate if you want to force navigation based on buttonPopupB
    if (
      buttonPopupB &&
      location.pathname !== "/faculty-and-students" &&
      location.pathname !== "/faculty-published-textbooks"
    ) {
      navigate("/faculty-and-students/");
      onUpdatePopupB(true);
    }
  }, [buttonPopupB, navigate, location.pathname, onUpdatePopupB]);

  return (
    <>
      <PopupIcons trigger={props.buttonPopupB} setTrigger={props.onUpdatePopupB} columnPosition="colB">
        <ul className="circle-container">
          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgStudentDemographic})` }}
              onClick={() => setButtonPopupB2(true)}
            >
              <span className="small">Student Demographics</span>
            </Link>
          </li>
          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${sarahJ})` }}
              to="/student-highlights"
            >
              <span className="small">Student Highlights</span>
            </Link>
          </li>
          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgCalc})` }}
              onClick={() => setButtonPopupB3(true)}
            >
              <span>Student Financial Aids</span>
            </Link>
          </li>

          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgGraph})` }}
              onClick={() => setButtonPopupB4(true)}
            >
              <span>Student Recruiting Stats</span>
            </Link>
          </li>

          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgSpeaker})` }}
              onClick={() => setButtonPopupB5(true)}
            >
              <span>Faculty Awards</span>
            </Link>
          </li>

          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgPeople})` }}
              onClick={() => setButtonPopupB6(true)}
            >
              <span className="small">Faculty Fellowships & Professorships</span>
            </Link>
          </li>

          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${nicoleD})` }}
              to="/faculty-highlights"
            >
              <span>Faculty Highlights</span>
            </Link>
          </li>

          <li>
            <Link
              className="image-btn image-link"
              style={{ backgroundImage: `url(${imgBook})` }}
              // onClick={() => setButtonPopupB1(true)}
              to="/faculty-published-textbooks"
            >
              <span>2024-2025 Published Faculty Textbooks</span>
            </Link>
          </li>
        </ul>
      </PopupIcons>

      {/*  FACULTY POPUP ********************************************************** */}
      <PopupLightbox
        trigger={buttonPopupB2}
        setTrigger={setButtonPopupB2}
        columnPosition="colB"
        slugCategory={""}
        styles="blue-lightbox"
      >
        <h3>Student Demographics</h3>

        <table>
          <thead>
            <tr>
              <th>Student Demographics</th>
              <th>BS Acc</th>
              <th>MACC</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Married</td>
              <td>18%</td>
              <td>19%</td>
            </tr>
            <tr>
              <td>Returned Missionary</td>
              <td>78%</td>
              <td>82%</td>
            </tr>
            <tr>
              <td>Bilingual</td>
              <td>66%</td>
              <td>64%</td>
            </tr>
            <tr>
              <td>International</td>
              <td>6%</td>
              <td>6%</td>
            </tr>
          </tbody>
        </table>
        <small>*Demographics for male & female will be in the program highlights</small>
      </PopupLightbox>

      <PopupLightbox trigger={buttonPopupB7} setTrigger={setButtonPopupB7} columnPosition="colB" slugCategory={""}>
        <h3>Student Highlights</h3>

        <table>
          <thead>
            <tr>
              <th></th>
              <th>MACC</th>
              <th>BS Acc</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Married</td>
              <td>47%</td>
              <td>19%</td>
            </tr>
            <tr>
              <td>Returned Missionaries</td>
              <td>83%</td>
              <td>54%</td>
            </tr>
            <tr>
              <td>Bilingual</td>
              <td>82%</td>
              <td>64%</td>
            </tr>
          </tbody>
        </table>
        <small>*The demographics for male, female, and international will be in the program highlights</small>
      </PopupLightbox>

      <PopupLightbox trigger={buttonPopupB3} setTrigger={setButtonPopupB3} columnPosition="colB" slugCategory={""}>
        <h3>Financial Aid</h3>

        <table>
          <thead>
            <tr>
              <th>BYU SOA Financial Aid</th>
              <th>BS Acc</th>
              <th>MAcc</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Number of Students Receiving Scholarships</td>
              <td>101</td>
              <td>277</td>
            </tr>
            <tr>
              <td>Percentage of Students Receiving Scholarships</td>
              <td>22%</td>
              <td>69%</td>
            </tr>
          </tbody>
        </table>
      </PopupLightbox>

      <PopupLightbox trigger={buttonPopupB4} setTrigger={setButtonPopupB4} columnPosition="colB" slugCategory={""}>
        <h3>Student Recruiting Stats</h3>
        <table>
          <tbody>
            <tr>
              <td>Student Recruiting Unique Hiring Firms</td>
              <td>103</td>
            </tr>
            <tr>
              <td>Top States</td>
              <td>Utah, California, Texas, Arizona, New York </td>
            </tr>
          </tbody>
        </table>

        <h4 className="headingSpacer">BS Acc Students</h4>
        <img src={graphBSAcc} alt="BS Acc Students" />

        <h4 className="headingSpacer">MAcc Students</h4>
        <img src={graphMAcc} alt="MAcc Students" />
      </PopupLightbox>

      <PopupLightbox
        trigger={buttonPopupB5}
        setTrigger={setButtonPopupB5}
        columnPosition="colB"
        slugCategory={""}
        backgroundStyle="blue-lightbox"
      >
        <h3>SOA Faculty Awards</h3>
        <div className="entry-row">
          <div className="entry-col entry-name">Bill Taylor</div>
          <div className="entry-col entry-title">2025 IMA Research Foundation Distinguished Scholar</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Brant Christensen Steve Glover</div>
          <div className="entry-col entry-title">2025 Notable Contribution to the Auditing Literature Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">
            Cassy Budd
            <br />
            Scott Summers
            <br />
            Jeff Wilks
            <br />
            David Wood
          </div>
          <div className="entry-col entry-title">
            Ernst & Young Foundation-sponsored 2025 Innovation in Accounting Education Award
          </div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">David Wood</div>
          <div className="entry-col entry-title">
            2025 AICPA® Distinguished Achievement in Accounting Education Award
          </div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">David Wood</div>
          <div className="entry-col entry-title">2025 Issues in Accounting Education Best Paper Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">David Wood</div>
          <div className="entry-col entry-title">Karl G. Maeser Research and Creative Arts Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">
            Jeff Pickerd
            <br />
            David Wood
            <br />
            Scott Emett
            <br />
            Marc Eulerich
          </div>
          <div className="entry-col entry-title">AIS Midyear Meeting 2025 Best Paper Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Melissa Larson</div>
          <div className="entry-col entry-title">UACPA’s Women to Watch: Experienced Leader Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Melissa Larson</div>
          <div className="entry-col entry-title">General Education Professorship Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Michael Drake</div>
          <div className="entry-col entry-title">Wesley P. Lloyd Award for Distinction in Graduate Education</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Monte Swain</div>
          <div className="entry-col entry-title">Lifetime Contribution to Management Accounting Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Monte Swain</div>
          <div className="entry-col entry-title">AAA 2025 Lifetime Service Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Nicole Donahoo</div>
          <div className="entry-col entry-title">Timothy Pearson Best Dissertation Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Ryan Sommerfeldt</div>
          <div className="entry-col entry-title">2025 IMA Emerging Scholar Award</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Steve Smith</div>
          <div className="entry-col entry-title">2025 Glen McLaughlin Prize for Ethics in Accounting Research</div>
        </div>
        <div className="entry-row">
          <div className="entry-col entry-name">Zach Fox</div>
          <div className="entry-col entry-title">2025 AAA Competitive Manuscript Award</div>
        </div>
      </PopupLightbox>

      <PopupLightbox
        trigger={buttonPopupB6}
        setTrigger={setButtonPopupB6}
        columnPosition="colB"
        slugCategory={""}
        backgroundStyle="blue-lightbox"
      >
        <h3>Professorships</h3>

        <table>
          <thead>
            <tr>
              <th>Professorship Title</th>
              <th>2024-25 Recipient</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>W. Steve Albrecht</td>
              <td>Melissa F. Lewis-Western</td>
            </tr>
            <tr>
              <td>Andersen Foundation</td>
              <td>Scott L. Summers</td>
            </tr>
            <tr>
              <td>Glenn D. Ardis</td>
              <td>David A. Wood</td>
            </tr>
            <tr>
              <td>Robert Call/Deloitte</td>
              <td>Brian C. Spilker</td>
            </tr>
            <tr>
              <td>Deloitte</td>
              <td>Monte R. Swain</td>
            </tr>
            <tr>
              <td>EY</td>
              <td>T. Jeffrey Wilks</td>
            </tr>
            <tr>
              <td>KPMG</td>
              <td>Troy K. Lewis</td>
            </tr>
            <tr>
              <td>John W. and Nancy S. Hardy</td>
              <td>Jacob R. Thornock</td>
            </tr>
            <tr>
              <td>E. Dee & Patricia Hubbard</td>
              <td>Melissa P. Larson</td>
            </tr>
            <tr>
              <td>KPMG</td>
              <td>F. Greg Burton</td>
            </tr>
            <tr>
              <td>LeRay McAllister/Deloitte Foundation</td>
              <td>Douglas F. Prawitt</td>
            </tr>
            <tr>
              <td>Mary & Ellis</td>
              <td>Mark F. Zimbelman</td>
            </tr>
            <tr>
              <td>Norm & Cindy Nemrow Excellence in Teaching</td>
              <td>Cassy J. Budd</td>
            </tr>
            <tr>
              <td>K. Fred Skousen</td>
              <td>Michael S. Drake</td>
            </tr>
            <tr>
              <td>Robert J. Smith</td>
              <td>William B. Tayler</td>
            </tr>
            <tr>
              <td>PwC</td>
              <td>Joshua A. Lee</td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr>
              <th>Fellowship Title</th>
              <th>2024-25 Recipient</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>LeAnn Albrecht</td>
              <td>Abigail Allen</td>
            </tr>
            <tr>
              <td>Andersen Foundation</td>
              <td>Timothy A. Seidel</td>
            </tr>
            <tr>
              <td>Deloitte</td>
              <td>Brant E. Christensen</td>
            </tr>
            <tr>
              <td>Rachel Martin</td>
              <td>Jon N. Kerr</td>
            </tr>
            <tr>
              <td>PwC</td>
              <td>Travis Dyer</td>
            </tr>
            <tr>
              <td>Warnick/Deloitte</td>
              <td>Steven D. Smith</td>
            </tr>
            <tr>
              <td>Deloitte</td>
              <td>Jonathan T. Liljegren</td>
            </tr>
          </tbody>
        </table>
      </PopupLightbox>

      <PopupLightbox trigger={buttonPopupB8} setTrigger={setButtonPopupB8} columnPosition="colB" slugCategory={""}>
        <h3>Faculty Highlights</h3>

        <p>
          <strong>Brian Spilker, John Barrick, Troy Lewis, and Ron Worsham</strong>, <br />
          McGraw Hill's Essential of Federal Taxation (2025 Edition), McGraw-Hill
        </p>
        <p>
          <strong>Brian Spilker, John Barrick, Troy Lewis, and Ron Worsham</strong>, <br />
          McGraw Hill's Taxation of Individuals and Business Entities (2025 Edition), McGraw Hill
        </p>

        <p>
          <strong>Michael Drake and Jacob Thornock</strong>, <br />
          Financial Accounting for Managers (2024 Edition), McGraw Hill
        </p>

        <p>
          <strong>Brian Spilker</strong>, <br />
          McGraw Hill's Essential of Federal Taxation (2025 Edition), McGraw-Hill
        </p>
        <p>
          <strong>Brian Spilker</strong>, <br />
          McGraw Hill's Taxation of Individuals and Business Entities (2025 Edition), McGraw Hill
        </p>
        <p>
          <strong>Scott Summers and David Wood</strong>, <br />
          Accounting Information Systems (16* Edition), Pearson
        </p>

        <p>
          <strong>Bill Tayler</strong>, <br />
          Corporate Financial Accounting (17 Edition), Cengage Learning
        </p>
      </PopupLightbox>

      <PopupLightbox
        trigger={buttonPopupB1}
        setTrigger={(val) => {
          setButtonPopupB1(val);
          // Only navigate when closing the popup and the slug is /faculty-published-textbooks
          if (
            !val &&
            (location.pathname === "/faculty-published-textbooks" ||
              location.pathname === "/faculty-published-textbooks/")
          ) {
            navigate("/faculty-and-students", { replace: true });
          }
        }}
        columnPosition="colB"
        slugCategory={""}
        backgroundStyle="blue-lightbox"
      >
        <h3>Faculty Textbooks</h3>

        <div className="entry-row">
          <div className="entry-col center-text">
            <p>
              <strong>Theodore Christensen, David Cottrell and Cassy Budd,</strong> Advanced Financial Accounting (2025
              Edition), McGraw-Hill
            </p>

            <p>
              <strong>William Messier Jr, Steven Glover, Douglas Prawitt and Brant Christensen,</strong> Auditing &
              Assurance Services: A Systematic Approach (2025 Edition), McGraw-Hill
            </p>

            <p>
              <strong>Wayne Thomas, Michael Drake, Jake Thornock and David Spiceland,</strong> Financial Accounting for
              Managers (2nd Edition), McGraw-Hill
            </p>

            <p>
              <strong>Carl Warren, Jeff Jones, and William Tayler</strong> Corporate Financial Accounting (17th
              Edition), Cengage Learning
            </p>

            <p>
              <strong>David Wood,</strong> Rewiring your Mind for AI: Harnessing the Power of Artificial Intelligence to
              Transform your Thinking, Technics Publications
            </p>
          </div>
        </div>
      </PopupLightbox>
    </>
  );
};

export default MiddleY;
